export default __webpack_public_path__ + "static/inc-c9f75927ad9f258526f6247d92a1d7c3.svg";